import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';

import { toast } from 'react-toastify';
import { Close } from '@mui/icons-material';
import { WithdrawIcon } from '../../../../vectors/index';
import { useWithdrawApplication } from '@features/applicant/hooks/useWithdrawApplication';

type WithdrawApplicationProps = {
  isOpen: boolean;
  handleClose: () => void;
  applicationId?: number | null;
  applicationName?: string | null;
  decline?: boolean;
};

const WithdrawApplication: FC<WithdrawApplicationProps> = ({
  isOpen,
  handleClose,
  applicationId,
  applicationName,
  decline,
}) => {
  const [errorText, setErrorText] = useState('');

  const { withdrawApplication, isWithdrawApplicationLoading } =
    useWithdrawApplication({
      setErrorText,
    });

  const handleSubmit = () => {
    const options = {
      onSuccess: (data: { status: number; message: string }) => {
        if (data.status === 200) {
          toast.success(data.message);
          handleClose();
        }
      },
    };

    applicationId &&
      withdrawApplication({ application_id: applicationId }, options);
  };
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
        <br />
        <WithdrawIcon />
        <br />
        {decline ? (
          <Typography variant="h4">
            Decline Application
          </Typography>
        ) : (
          <Typography variant="h4">
            This will withdraw your application for <br/> <b>{applicationName}</b>, and
            if you're still interested in the position you'll need to reapply.
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mb={2}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <Typography textAlign="center" variant="body1" color="text.secondary">
            {decline
              ? 'Declining this opportunity will withdrawal your application and you will not be hired for this position, this cannot be undone. Would you like to decline this job opportunity?'
              : ' FYI, your resume information can be updated without withdrawing your application at any time.'}
          </Typography>
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={handleSubmit}
            loading={isWithdrawApplicationLoading}
          >
            {decline ? 'Decline' : 'Withdraw'}
          </LoadingButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default WithdrawApplication;
